import Blue from "~/core";
import shave from 'shave';
import Swiper, { Navigation, Autoplay } from 'swiper';

new Blue({
	name: 'Video Library Slideshow',
	selector: ".js-video-library-swiper",
	setup(registration) {
        Swiper.use([Navigation]);
        // [slidesPerView, spaceBetween]
        const truncate = registration.querySelectorAll('.text-truncate')
        const maxheight = 50
        let sizesLg = [3.5,30]
        if(registration.classList.contains('video-library-swiper--large')) {
          // variant for the fundamentals page
          sizesLg = [3,15]
        }
        // Swiper.use([Autoplay]);
        setTimeout(() => {
          const swiper = new Swiper(registration, {
            direction: 'horizontal',
            // slidesPerView: 3,
            // spaceBetween: 30,
            breakpoints: {
                1: {
                    slidesPerView: 1.5,
                    spaceBetween: 30,
                },
                576: {
                  slidesPerView: 2.5,
                  spaceBetween: 30,
                },
                900: {
                    slidesPerView: sizesLg[0],
                    spaceBetween: sizesLg[1],
                }
              },
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
          });
          truncate.forEach(e => {
            shave(e, maxheight)
          });
          
        }, 750);
        
	}
});